import { useNewUserAccessRights } from '@app/hooks/useNewUserAccessRights';

export const useUsersAccessRights = () => {
  const {
    userAccessRights: {
      Users: {
        IsOn: hasRightToModuleView,
        IsUsers: hasUserRightToUserRegistry,
        IsEmployees: hasUserRightToEmployeeRegistry,
        IsCreate: hasUserRightToCreate,
        IsChangeOwner: hasUserRightToChangeOwner,
        IsChangeBranches: hasUserRightToChangeBranches,
        IsExport: hasUserRightToExport,
        IsImport: hasUserRightToImport,
        IsEdit: hasUserRightToEdit,
        IsDelete: hasUserRightToDelete,
      },
      Positions: { IsCreate: hasUserRightToCreatePosition },
      AccessRights: { IsOn: hasUserRightToViewAccessRightTab },
      ClientServices: {
        IsDelete: hasUserRightToDeleteService,
        IsCreate: hasUserRightToCreateService,
      },
    },
  } = useNewUserAccessRights();

  return {
    hasRightToModuleView,
    hasUserRightToUserRegistry,
    hasUserRightToEmployeeRegistry,
    hasUserRightToCreate,
    hasUserRightToCreatePosition,
    hasUserRightToChangeOwner,
    hasUserRightToChangeBranches,
    hasUserRightToExport,
    hasUserRightToImport,
    hasUserRightToEdit,
    hasUserRightToViewAccessRightTab,
    hasUserRightToDelete,
    hasUserRightToDeleteService,
    hasUserRightToCreateService,
  };
};
